export default "__VITE_ASSET__C5kpBib4__"